import React, { useState } from "react";
import {
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  TextField,
  Typography,
  Button,
} from "@mui/material";

const OfferForm = ({ onSubmit, selectedOffer }) => {
  const [formData, setFormData] = useState({
    bankName: selectedOffer.BankName || "",
    instrumentType: selectedOffer.InstrumentType || "",
    interestRate: selectedOffer.InterestRate || "",
    issuanceCharges: selectedOffer.IssuanceCharges || "",
    confirmationCharges: selectedOffer.ConfirmationCharges || "",
    tenorOffered: selectedOffer.Tenor || "",
    currency: selectedOffer.Currency || "",
    totalCost: selectedOffer.TotalCost || "",
    conditionsSummary: selectedOffer.ConditionsSummary || "",
    offerValidity: selectedOffer.OfferValidity || "",
    docChecklistAgreed: selectedOffer.DocChecklistAgreed || "",
    status: selectedOffer.Status || "",
  });
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState({
    product: "",
    grade: "",
    origin: "",
    destination: "",
    deliveryPeriod: "",
    quantity: "",
    incoterms: "",
    paymentTerms: "",
    packaging: "",
    deliveryPort: "",
    deliveryPeriodFrom: null,
    deliveryPeriodTill: null,
    deliveryPeriodTillRange: "",
    validUntil: null,
    validUntilRange: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  console.log("formData##", formData);
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("formData@@@", formData);
    // onSubmit(formData);
    // Reset form after submission
    setFormData({
      bankName: "",
      instrumentType: "",
      interestRate: "",
      issuanceCharges: "",
      confirmationCharges: "",
      tenorOffered: "",
      currency: "",
      totalCost: "",
      conditionsSummary: "",
      offerValidity: "",
      docChecklistAgreed: "",
      status: "",
    });
  };

  return (
    
      <section className="product-details2" style={{ paddingBottom: "16px" }}>
        <div className="row g-3" style={{ padding: "0 16px" }}>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.bankName}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Bank Name *
              </Typography>
              <TextField
                name="bankName"
                value={formData.bankName}
                onChange={handleChange}
                fullWidth
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Bank Name" }}
              />
              {errors.bankName && (
                <FormHelperText>{errors.bankName}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.instrumentType}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Instrument Type *
              </Typography>
              <Select
                name="instrumentType"
                value={formData.instrumentType}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Instrument Type" }}
              >
                <MenuItem value="" disabled>
                  Select Instrument Type
                </MenuItem>
              </Select>
              {errors.instrumentType && (
                <FormHelperText>{errors.instrumentType}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.interestRate}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Interest Rate/Margin (%)
              </Typography>
              <TextField
                type="number"
                step="0.01" 
                inputMode="decimal" 
                name="interestRate"
                value={formData.interestRate}
                onChange={handleChange}
               
               
              />
              {errors.interestRate && (
                <FormHelperText>{errors.interestRate}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.issuanceCharges}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Issuance Charges
              </Typography>
              <TextField
                name="issuanceCharges"
                value={formData.issuanceCharges}
                onChange={handleChange}
                
                type="number"
                step="0.01" 
                inputMode="decimal" 
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Issuance Charges" }}
              />
              {errors.issuanceCharges && (
                <FormHelperText>{errors.issuanceCharges}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.confirmationCharges}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Confirmation Charges
              </Typography>
              <TextField
                type="number"
                step="0.01" 
                inputMode="decimal"
                name="confirmationCharges"
                value={formData.confirmationCharges}
                onChange={handleChange}
                
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Confirmation Charges" }}
              />
              {errors.confirmationCharges && (
                <FormHelperText>{errors.confirmationCharges}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.tenorOffered}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Tenor Offered
              </Typography>
              <TextField
                name="tenorOffered"
                value={formData.tenorOffered}
                onChange={handleChange}
                fullWidth
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Tenor Offered" }}
              />
              {errors.tenorOffered && (
                <FormHelperText>{errors.tenorOffered}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: " 8px" }}
              error={!!errors.currency}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Currency
              </Typography>
              <Select
                name="currency"
                value={formData.currency}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Currency" }}
              >
                <MenuItem value="" disabled>
                  Select Currency
                </MenuItem>
                <MenuItem value="USD">USD</MenuItem>
                <MenuItem value="EUR">EUR</MenuItem>
                <MenuItem value="GBP">GBP</MenuItem>
              </Select>
              {errors.currency && (
                <FormHelperText>{errors.currency}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.totalCost}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Total Cost
              </Typography>
              <TextField
                type="number"
                step="0.01" 
                inputMode="decimal"
                name="totalCost"
                value={formData.totalCost}
                onChange={handleChange}
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Total Cost" }}
              />
              {errors.totalCost && (
                <FormHelperText>{errors.totalCost}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <Typography variant="body2" sx={{ marginBottom: "8px" }}>
              Conditions Summary
            </Typography>
            <textarea
              id="conditionsSummary"
              name="conditionsSummary"
              value={formData.conditionsSummary || ""}
              className="form-control"
              rows="4"
            />
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.offerValidity}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Offer Validity
              </Typography>
              <TextField
                name="offerValidity"
                value={formData.offerValidity}
                onChange={handleChange}
                type="date"
                fullWidth
                sx={{ backgroundColor: "white" }}
                InputLabelProps={{ shrink: true }}
                inputProps={{ "aria-label": "Offer Validity" }}
              />
              {errors.offerValidity && (
                <FormHelperText>{errors.offerValidity}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.docChecklistAgreed}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Doc Checklist Agreed
              </Typography>
              <Select
                name="docChecklistAgreed"
                value={formData.docChecklistAgreed}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Doc Checklist Agreed" }}
              >
                <MenuItem value="" disabled>
                  Select Option
                </MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
              {errors.docChecklistAgreed && (
                <FormHelperText>{errors.docChecklistAgreed}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div className="col-12 col-sm-6 col-md-3">
            <FormControl
              sx={{ minWidth: "100%", padding: "8px" }}
              error={!!errors.status}
            >
              <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                Status
              </Typography>
              <Select
                name="status"
                value={formData.status}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Status" }}
              >
                <MenuItem value="" disabled>
                  Select Status
                </MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
              {errors.status && (
                <FormHelperText>{errors.status}</FormHelperText>
              )}
            </FormControl>
          </div>
          {/* <div className="col-12 col-sm-6 col-md-3">
            <button
              type="button"
              className="submit-btn"
              onClick={handleSubmit}
              aria-label="Submit"
              sx={{ marginTop: "16px", marginLeft: "16px" }}
            >
              Submit
            </button>
          </div> */}
        </div>
      </section>
    
  );
};

export default OfferForm;
